import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { SafeHtmlPipe } from "../../pipes/safe-html.pipe";
import { PosterCardComponent } from "../poster-card/poster-card.component";
import { Movie, PageService, SquarePromo } from '../../services/Page/page.service';
import { CommonModule } from '@angular/common';
import { RoundArrowLeftComponent } from "../UI/round-arrow-left/round-arrow-left.component";
import { RoundArrowRightComponent } from "../UI/round-arrow-right/round-arrow-right.component";
import { gsap, Expo, Quad } from 'gsap';
import { SquarerCardComponent } from "../square-card/square-card.component";

@Component({
    selector: 'app-square-list',
    imports: [
        CommonModule,
        SafeHtmlPipe,
        PosterCardComponent,
        RoundArrowLeftComponent,
        RoundArrowRightComponent,
        SquarerCardComponent
    ],
    templateUrl: './square-list.component.html',
    styleUrl: './square-list.component.scss'
})
export class SquareListComponent {
    @Input('title') title: string = ''
    @Input('size') size: number = 20
    @Input('isGenre') isGenre: boolean = false
    // @Input('movies') movies: Movie[] = []

    private _squarePromo: SquarePromo[] = [];
    @Input('SquarePromo')
    public get squarePromo(): SquarePromo[] {
        return this._squarePromo;
    }
    public set squarePromo(value: SquarePromo[]) {
        this._squarePromo = value;

        if(this._squarePromo.length > this.numberOnScreen) {
            this.nextEnabled = true
        }
    }

    @Input('numberOnScreen') numberOnScreen: number = 5

    @ViewChild('sliderHolder') sliderHolder: ElementRef | undefined
    @ViewChild('slider') slider: ElementRef | undefined
    
    cardWidth: string = "20%"
    currentIndex: number = 0

    prevEnabled: boolean = false
    nextEnabled: boolean = false

    constructor(
        public pageService: PageService
    ) { }

    ngOnInit() {
        this.cardWidth = (100 / this.numberOnScreen) + '%'
    }

    gotoPosition(index: number) {
        if (index < 0) return
        if (index >= this.squarePromo.length - this.numberOnScreen + 2) return

        let dir = -1
        if (this.currentIndex < index) {
            dir = 1
        }

        if(index == 0) {
            this.prevEnabled = false
        } else {
            this.prevEnabled = true
        }
        if(index >= this.squarePromo.length - this.numberOnScreen + 1) {
            this.nextEnabled = false
        }
        else {
            this.nextEnabled = true
        }
        if(this.squarePromo.length < this.numberOnScreen) {
            this.nextEnabled = false
        }

        // let width = this.sliderHolder?.nativeElement.getBoundingClientRect().width

        // gsap.to('app-poster-card', 1, { x: -1 * (width * index), ease: Expo.easeInOut })
        // this.currentIndex = index

        let width = this.sliderHolder?.nativeElement.getBoundingClientRect().width / this.numberOnScreen

        let elements = Array.from(this.slider?.nativeElement.children)
        let prev = elements.slice(0, this.currentIndex)
        let visible = elements.slice(this.currentIndex, this.numberOnScreen+1 + this.currentIndex)
        let next = elements.slice(this.currentIndex + this.numberOnScreen+1, elements.length)

        if (this.currentIndex > index) {
            prev = elements.slice(0, this.currentIndex -1 )
            visible = elements.slice(this.currentIndex -1, this.numberOnScreen + this.currentIndex)
            next = elements.slice(this.currentIndex + this.numberOnScreen, elements.length)
        }


        // gsap.to(elements, 1, { x: -1 * (width * index), stagger: dir * 0.015, ease: Expo.easeInOut })
        gsap.to(prev, 0.5, { x: -1 * (width * index), ease: Expo.easeInOut })
        gsap.to(visible, 0.5, { x: -1 * (width * index), stagger: dir * 0.02, ease: Expo.easeInOut })
        gsap.to(next, 0.5, { x: -1 * (width * index), ease: Expo.easeInOut })
        // this.elem?.forEach((elementRef: ElementRef) => {
        // });

        this.currentIndex = index
    }

    next() {
        this.gotoPosition(this.currentIndex + 1)
    }

    prev() {
        this.gotoPosition(this.currentIndex - 1)
    }


}
